module.exports = __webpack_public_path__ + "img/sixpackcarrier70.a1615e04.jpg";